/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {AccordionDefaultExample, AccordionLargeContentExample, AccordionCustomisationExample, AccordionContainerExample, AccordionGroupExample, AccordionNestedExample, AccordionPlainVariant, AccordionDisabledExample, AccordionDescriptionExample, AccordionFilledExample} from 'Docs/uilib/components/accordion/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    strong: "strong",
    a: "a",
    code: "code"
  }, _provideComponents(), props.components), {VisibleWhenVisualTest, VisibilityByTheme} = _components;
  if (!VisibilityByTheme) _missingMdxReference("VisibilityByTheme", true);
  if (!VisibleWhenVisualTest) _missingMdxReference("VisibleWhenVisualTest", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Single Accordion"
    }), "\n", _jsx(AccordionDefaultExample, {}), "\n", _jsx(_components.h3, {
      children: "Accordion with large title and content"
    }), "\n", _jsx(AccordionLargeContentExample, {}), "\n", _jsx(_components.h3, {
      children: "Grouped Accordion"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " Please have a read on the ", _jsx(_components.a, {
        href: "/uilib/components/accordion#unexpected-behavior",
        children: "unexpected behavior"
      }), " thoughts."]
    }), "\n", _jsx(AccordionGroupExample, {}), "\n", _jsx(_components.h3, {
      children: "Customized Accordion"
    }), "\n", _jsx(AccordionCustomisationExample, {}), "\n", _jsx(_components.h3, {
      children: "Nested Accordions"
    }), "\n", _jsx(AccordionNestedExample, {}), "\n", _jsx(VisibleWhenVisualTest, {
      children: _jsx(AccordionPlainVariant, {})
    }), "\n", _jsx(_components.h3, {
      children: "Disabled"
    }), "\n", _jsx(_components.p, {
      children: "Accordion can be disabled, though is not exactly defined what the use case is."
    }), "\n", _jsx(AccordionDisabledExample, {}), "\n", _jsxs(_components.h3, {
      children: ["Variant ", _jsx(_components.code, {
        children: "filled"
      })]
    }), "\n", _jsx(VisibilityByTheme, {
      visible: "sbanken",
      children: _jsx(_components.p, {
        children: "This variant does not have any different styling in the Sbanken theme."
      })
    }), "\n", _jsx(AccordionFilledExample, {}), "\n", _jsx(VisibleWhenVisualTest, {
      children: _jsx(AccordionDescriptionExample, {})
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
